import { Form, Modal, Select } from "antd";

const ReassignQC = ({ isOpen, onOk, onCancel, allQc, props }) => {
  return (
    <>
      <Modal
        title="Reassign QC"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        okText="Yes"
        cancelText="No"
      >
        <p className="text-sm">Are you sure want to reassign the QC?</p>
        <Form
          name="Reassign QC"
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Form.Item
            label="Choose QC"
            name="Choose QC"
            rules={[
              {
                required: true,
                message: "Please enter your Choose QC",
              },
            ]}
          >
            <Select
              size="large"
              placeholder="Select"
              options={allQc}
              showSearch
              filterOption={(input, allQc) =>
                (allQc?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              onChange={(e) => {
                props?.setSelectedQc(e);
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default ReassignQC;
